/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// ImageTag is a small string that indicate the purpose of an image. There're some predefined image
// tags in our platform which are prefixed "btg:". User can define their own tags for use in their
// customize storefront. Each tag is associated to at most one image.
export enum ImageTag {
  // Primary image to be displayed for the given object (e.g., Product) associated with this image.
  MainImage = 'btg::image::main',

  // (Product-only) Images in addition to btg:main which will be accessed via further clicks in
  // Product page.
  ProductAlt1Image = 'btg::image::product-alt1',
  ProductAlt2Image = 'btg::image::product-alt2',
  ProductAlt3Image = 'btg::image::product-alt3',
  ProductAlt4Image = 'btg::image::product-alt4',
  ProductAlt5Image = 'btg::image::product-alt5',
  ProductAlt6Image = 'btg::image::product-alt6',
  ProductAlt7Image = 'btg::image::product-alt7',
  ProductAlt8Image = 'btg::image::product-alt8',
  ProductAlt9Image = 'btg::image::product-alt9',

  // (Product-only) "Swatch" image for embedding in the button for selecting variations
  SwatchImage = 'btg::image::swatch',
}

export interface ImageData {
  readonly id: string;
  readonly tag: ImageTag;
  readonly handle: string;
}

export class Image {
  public constructor(private readonly data: ImageData) { }

  get id() { return this.data.id; }
  get tag() { return this.data.tag; }
  get handle() { return this.data.handle; }

  get src() { return this.transformedSrc(); }
  get thumbnail() { return this.transformedSrc(200, 200); }

  public transformedSrc(maxWidth?: number, maxHeight?: number) {
    // TODO
    return this.handle;
  }
}
